module.exports = __webpack_public_path__ + "img/Summer for Seniors.98c66230.jpg";